<template>
  <div :class="{ field: field || label, required }">
    <div v-if="label" class="label capitalize-fl">
      {{ label }} <i class="question circle icon" :title="$t('MARKDOWN_EDITOR_HELP')" />
    </div>
    <div
      id="container"
      @dragover.stop.prevent="dragover"
      @dragenter.stop.prevent="dragenter"
      @dragexit.stop.prevent="dragexit"
      @dragleave.stop.prevent="dragexit"
      @drop.stop.prevent="drop"
    >
      <div class="drop-target" :class="{ over: dragging }" style="pointer-events: none;">
        <div class="drop-message">{{ $t('DROP_HERE_TO_ATTACH') }}</div>
      </div>
      <div class="editor" ref="editor" :style="{ height: height }"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';
#container {
  position: relative;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  margin-bottom: 10px;

  &:focus-within {
    border: 1px solid #85b7d9;
  }
}

#container .drop-target {
  display: none;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;

  &.over {
    display: flex;
    align-items: center;
    background-color: rgba(133, 183, 217, 0.9);
  }

  .drop-message {
    width: 400px;
    height: 50px;
    line-height: 50px;
    margin: auto;
  }
}

.editor {
  margin: 10px;
}

.label {
  font-weight: bold;
  margin-bottom: 0.3rem;
  margin-top: 0.6rem;
  font-size: 0.95rem;
}
</style>

<script>
// @flow
import * as monaco from 'monaco-editor' // needs to be imported this way in order to include only subset of languages

export default {
  name: 'markdown-editor',

  props: ['value', 'height', 'label', 'field', 'required'],

  data() {
    return {
      editor: null,
      dragging: false
    }
  },

  methods: {
    init() {
      this.editor = monaco.editor.create(this.$refs.editor, {
        value: this.value,
        language: 'markdown',
        tabSize: 2,
        codeLens: false,
        glyphMargin: false,
        lineNumbers: 'off',
        wordWrap: 'on',
        folding: false,
        // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
        lineDecorationsWidth: 0,
        lineNumbersMinChars: 0,
        scrollbar: { vertical: 'hidden', verticalScrollbarSize: 0 },
        minimap: { enabled: false }
      })

      this.editor.onDidChangeModelContent(() => {
        this.$emit('contentchanged', this.editor.getValue())
      })

      // Auto-format
      this.editor.updateOptions({
        autoIndent: true,
        formatOnPaste: true,
        formatOnType: true
      }),
        // Theme
        monaco.editor.defineTheme('MarkdownEditorTheme', {
          base: 'vs',
          inherit: true,
          rules: [{}],
          colors: {
            'editor.lineHighlightBackground': '#FFFFFF',
            'editorLineNumber.foreground': '#008800',
            'editorWarning.foreground': '#FFCC00',
            'editorInfo.foreground': '#FFCC00'
          }
        })
      monaco.editor.setTheme('MarkdownEditorTheme')
    },

    insertAtCaret(t) {
      this.editor.executeEdits('', [
        {
          range: this.editor.getSelection(),
          identifier: { major: 1, minor: 1 },
          forceMoveMarkers: true,
          text: t
        }
      ])
    },

    content() {
      return this.editor.getValue()
    },

    dragover() {
      this.dragging = true
    },
    dragenter() {
      this.dragging = true
    },
    dragexit() {
      this.dragging = false
    },
    drop(e) {
      this.$emit('dropped', e)
      this.dragging = false
    }
  },

  mounted() {
    this.init()
  },

  watch: {
    value(v) {
      if (this.editor.getValue() != v) this.editor.setValue(v)
    }
  }
}
</script>
